import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getChallenges } from "../../../api/challenge";

const ChallengeTable = () => {
  const [challenges, setChallenges] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);  

  useEffect(() => {
    const fetchChallenges = async () => {
      try {
        const fetchedChallenges = await getChallenges();
        setChallenges(fetchedChallenges);
      } catch (error) {
        console.error("Error fetching challenges:", error);
        toast.error("Error fetching challenges");
      }
    };

    fetchChallenges();
  }, []);

  const indexOfLastChallenge = currentPage * itemsPerPage;
  const indexOfFirstChallenge = indexOfLastChallenge - itemsPerPage;
  const currentChallenges = challenges.slice(indexOfFirstChallenge, indexOfLastChallenge);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(challenges.length / itemsPerPage);

  return (
    <div>
      <div className="table-responsive">
        <table className="table table-hover table-bordered align-middle">
          <thead className="table-light border rounded">
            <tr>
              <th>S.no</th>
              <th>Challenge Name</th>
              <th>Created At</th>
              <th>Days of Challenge</th>
              <th>Tasks</th>
            </tr>
          </thead>
          <tbody>
            {currentChallenges.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                <td>{item.challenge_name}</td>
                <td>{new Date(item.created_at).toLocaleString()}</td>
                <td>{item.days_of_challenge}</td>
                <td>
                  {item.tasks.map((task, taskIndex) => (
                    <div key={taskIndex}>
                      <strong>{task.task_name}</strong>: {task.count} {task.unit} ({task.task_type})
                    </div>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <nav aria-label="Page navigation">
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link rounded mx-2"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
          </li>
          {[...Array(totalPages)].map((_, index) => (
            <li
              key={index}
              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
            >
              <button
                className="page-link rounded mx-2"
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link rounded mx-2"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default ChallengeTable;
